import { cn } from '@/utils/cn'
import * as AccordionPrimitive from '@radix-ui/react-accordion'
import { type VariantProps, cva } from 'class-variance-authority'
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react'

export const Accordion = AccordionPrimitive.Root

export const AccordionItem = forwardRef<
  ElementRef<typeof AccordionPrimitive.Item>,
  ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ ...props }, ref) => <AccordionPrimitive.Item ref={ref} {...props} />)
AccordionItem.displayName = 'AccordionItem'

export const AccordionTrigger = forwardRef<
  ElementRef<typeof AccordionPrimitive.Trigger>,
  ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger ref={ref} className={cn('outline-none', className)} {...props} />
  </AccordionPrimitive.Header>
))
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName

const accordionContentVariants = cva('overflow-hidden transition-all', {
  variants: {
    variant: {
      default: 'data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down',
      alternate:
        'data-[state=closed]:animate-accordion-up-alternate data-[state=open]:animate-accordion-down-alternate',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

export const AccordionContent = forwardRef<
  ElementRef<typeof AccordionPrimitive.Content>,
  ComponentPropsWithoutRef<typeof AccordionPrimitive.Content> & VariantProps<typeof accordionContentVariants>
>(({ className, variant, ...props }, ref) => (
  <AccordionPrimitive.Content ref={ref} className={cn(accordionContentVariants({ variant }), className)} {...props} />
))

AccordionContent.displayName = AccordionPrimitive.Content.displayName
